import * as React from "react";
import { useNavigate } from "react-router-dom";

import PrivacyPolicy from "../../../assets/profile/privacy-policy.svg";
import TermsCondition from "../../../assets/profile/terms-condition.svg";
import { TemplateSub } from "../../../components/layouts/TemplateSub";

import * as ROUTES from "../../../constants/routes";

export const LegalPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <TemplateSub page="Legal">
      <div className="px-4">
        <div className="flex flex-col gap-[10px] mt-[1rem] w-full">
          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.PRIVACY_POLICY)}
          >
            <img src={PrivacyPolicy} alt="" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Privacy Policy</p>
          </button>

          <button
            className="w-full cursor-pointer flex items-center gap-[16px] h-[54px] p-5 bg-[#171820] backdrop-blur-sm border border-[#171820] text-white hover:bg-white/20 hover:border-white/30 focus:ring-white/50 rounded-lg"
            onClick={() => navigate(ROUTES.TERMS_CONDITIONS)}
          >
            <img src={TermsCondition} alt="" width={20} height={20} />
            <p className="text-[white] text-[16px] ">Terms & Conditions</p>
          </button>
        </div>
      </div>
    </TemplateSub>
  );
};